@if (isVisible) {
  <ng-container
    *transloco="let t; scope: 'modalNetworkBlock'; read: 'modalNetworkBlock'"
  >
    <wrapper-modal [title]="getTitle(t)" (close)="handleClose()">
      <div
        #modalContainer
        tabindex="-1"
        class="flex flex-col gap-6 outline-none"
      >
        @if (isBlocked) {
          <p class="text-default">{{ t('blockedBody') }}</p>

          <div
            class="flex flex-col gap-1 p-4 rounded-lg border border-outlineDefault bg-gray-50"
          >
            <span class="text-sm font-medium text-secondary">
              {{ t('apiHostLabel') }}
            </span>
            <code
              class="text-base font-semibold break-all font-mono text-primary"
            >
              {{ diagnostics.getApiHost() }}
            </code>
          </div>

          <ul class="pl-5 space-y-2 text-default list-disc">
            <li>{{ t('tryOtherNetwork') }}</li>
            <li>{{ t('askIt') }}</li>
          </ul>

          <button
            type="button"
            class="flex items-center gap-2 text-left text-primary hover:underline"
            (click)="toggleDetails()"
            [attr.aria-expanded]="detailsExpanded"
          >
            <span [class.rotate-90]="detailsExpanded">▸</span>
            {{ t('detailsForIt') }}
          </button>

          @if (detailsExpanded) {
            <pre
              class="overflow-x-auto p-3 text-sm whitespace-pre-wrap rounded-lg bg-gray-50 border border-outlineDefault"
              [attr.aria-label]="t('detailsForIt')"
            >{{ diagnostics.getDetailsText() }}</pre>
          }
        } @else {
          <p class="text-default">{{ t('offlineBody') }}</p>
        }

        @if (diagnostics.isRetrying()) {
          <p
            class="text-sm text-secondary"
            role="status"
            aria-live="polite"
          >
            {{ t('checking') }}
          </p>
        } @else if (diagnostics.retryFeedback()) {
          <div
            class="p-3 rounded-lg border bg-yellow-50 border-yellow-200"
            role="status"
            aria-live="polite"
          >
            <p class="text-sm text-default">
              {{ getRetryFeedbackMessage(t) }}
            </p>
            @if (diagnostics.lastCheckedAt(); as checkedAt) {
              <p class="mt-1 text-xs text-secondary">
                {{
                  t('lastChecked', { time: formatLastChecked(checkedAt) })
                }}
              </p>
            }
          </div>
        }

        <div
          class="flex flex-col-reverse gap-2 for-laptop-up:flex-row for-laptop-up:justify-between w-full"
        >
          <default-button-outlined
            class="flex-grow w-full for-laptop-up:w-auto"
            [type]="'button'"
            [disabled]="diagnostics.isRetrying()"
            (click)="handleClose()"
          >
            {{ t('close') }}
          </default-button-outlined>

          <div
            class="flex flex-col gap-2 for-laptop-up:flex-row for-laptop-up:flex-grow"
          >
            @if (isBlocked) {
              <default-button-outlined
                class="flex-grow w-full"
                [type]="'button'"
                [disabled]="diagnostics.isRetrying()"
                (click)="handleCopyDetails()"
              >
                {{ t('copyDetails') }}
              </default-button-outlined>
            }
            <default-button-filled
              class="flex-grow w-full"
              [type]="'button'"
              [disabled]="diagnostics.isRetrying()"
              (click)="handleTryAgain()"
            >
              {{
                diagnostics.isRetrying() ? t('checking') : t('tryAgain')
              }}
            </default-button-filled>
          </div>
        </div>
      </div>
    </wrapper-modal>
  </ng-container>
}
